<div class="scopeAuditSection">
  <p-fieldset legend="Audit Trail" *ngIf="isDataLoaded">
    <div class="grid">
      <div class="col-6">
        <app-scope-audit-summary [summaryData]="scopeAuditSummaryDetails"
          (onItemSelected)="showAuditItemDetails($event)">
        </app-scope-audit-summary>
      </div>
      <div class="col-6 auditTrialDetailsSection">
        <app-audit-item-details
          [auditTrialDetails]="auditAttributeDetailsOfTransaction">
        </app-audit-item-details>
      </div>
    </div>
  </p-fieldset>
</div>
